import { useState } from "react";

const DENIALS = [
  {
    id: "blend",
    label: "Blend time",
    carrier: "Included in refinish",
    draft:
      "Regarding the blend allowance on adjacent panels: the carrier's own estimating guide lists blend as a not-included refinish operation — published refinish times do not include blending adjacent panels for color match, and the guide directs that blending be valued at 50% of the full refinish allowance. DEG inquiry #1847 confirms this against the current guide edition. Please add 1.4 hrs refinish labor for the left quarter blend.",
  },
  {
    id: "scans",
    label: "Pre/post scans",
    carrier: "Not warranted",
    draft:
      "Regarding pre- and post-repair diagnostic scans: the vehicle manufacturer's position statement requires a pre-repair scan to identify stored DTCs and a post-repair scan to verify system readiness after any collision repair. This is a required, not-included operation per the OEM procedure for this VIN's model year. Please add the scan operation at the posted labor rate.",
  },
  {
    id: "fpb",
    label: "Feather, prime & block",
    carrier: "Included in repair time",
    draft:
      "Regarding feather, prime and block on the repaired panel: the estimating guide's P-pages state that feather, prime and block is a not-included operation when performed on a repair panel, and is to be considered on the spot at the applicable refinish rate. Published repair times cover metal finishing only. Please add the operation per the guide's own labor Premise.",
  },
  {
    id: "cover",
    label: "Cover & protect",
    carrier: "That's overlap",
    draft:
      "Regarding cover and protect: masking adjacent panels, glass and trim to prevent overspray is a not-included operation under the guide's refinish section and is not absorbed by any other operation on this estimate. DEG inquiry #2213 documents this against the current edition. Please add cover car and jambs at the refinish labor rate.",
  },
  {
    id: "sealer",
    label: "Seam sealer",
    carrier: "Included in R&R",
    draft:
      "Regarding seam sealer on the rear quarter panel: R&R times cover removal and installation of the part only. Replicating the factory seam sealer bead is a not-included operation, and OEM repair procedure #60-82B requires it to maintain structural NVH and corrosion warranty. Please add seam sealer materials and labor as a separate line.",
  },
];

const AgentDemo = () => {
  const [active, setActive] = useState(DENIALS[0].id);
  const current = DENIALS.find((d) => d.id === active);

  return (
    <section
      data-testid="agent-demo-section"
      className="py-20 sm:py-28 bg-[#FAF8F5] border-b border-[#E7E5E4]"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="mb-10 max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-widest text-[#9A3412]">
            Try the agent
          </span>
          <h2 className="text-3xl sm:text-4xl font-normal text-stone-900 font-serif-display mt-2">
            Pick a denial you heard this week.
          </h2>
          <p className="text-sm text-stone-600 mt-3">
            Watch the agent draft the response. Every argument comes from the
            carrier's own estimating guide.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5 space-y-2">
            {DENIALS.map((d) => (
              <button
                key={d.id}
                data-testid={`denial-tab-${d.id}`}
                onClick={() => setActive(d.id)}
                className={`w-full text-left px-4 py-3.5 rounded border transition-colors flex items-center justify-between gap-4 ${
                  active === d.id
                    ? "border-[#9A3412] bg-white shadow-sm"
                    : "border-stone-200 bg-stone-100/60 hover:bg-white"
                }`}
              >
                <span>
                  <span className="block text-sm font-bold text-stone-900">
                    {d.label}
                  </span>
                  <span className="block text-xs text-stone-500 mt-0.5">
                    Carrier says: "{d.carrier}"
                  </span>
                </span>
                <span
                  className={`text-xs font-mono-ui ${
                    active === d.id ? "text-[#9A3412]" : "text-stone-400"
                  }`}
                >
                  →
                </span>
              </button>
            ))}
          </div>

          <div className="lg:col-span-7">
            <div
              data-testid="agent-draft-card"
              className="rounded-xl border border-stone-300 bg-white shadow-md overflow-hidden"
            >
              <div className="px-5 py-3 border-b border-stone-200 flex items-center justify-between">
                <span className="text-xs font-mono-ui text-stone-500">
                  <span className="inline-block w-2 h-2 rounded-full bg-[#9A3412] mr-2 align-middle" />
                  Brim agent · response to "{current.label.toLowerCase()}" denial
                </span>
                <span className="text-xs font-mono-ui text-stone-400 uppercase">
                  Draft · awaiting approval
                </span>
              </div>
              <div className="p-6">
                <p className="draft-text text-sm text-stone-800 leading-relaxed font-mono-ui">
                  {current.draft}
                </p>
                <div className="mt-6 pt-4 border-t border-stone-100 flex items-start gap-2">
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-amber-500 mt-1.5 shrink-0" />
                  <p className="text-xs text-stone-500">
                    Sample output. Live responses cite the current guide edition
                    and the DEG record for your claim. Nothing is sent until you
                    approve it.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgentDemo;
